import { Directive, HostBinding, Input, OnChanges } from '@angular/core';
import { BTN_CLASS_DICT, BTN_OUTLINE_CLASS_DICT, BTN_SIZE_DICT, ButtonColor, ButtonSize } from './button.utils';

@Directive({
  selector: '[nkButton]',
  standalone: true,
})
export class ButtonDirective implements OnChanges {
  @Input() public color: ButtonColor = 'primary';
  @Input() public size: ButtonSize | '' | undefined;
  @Input() public block = false;
  /**
   * Makes the buttons outline
   */
  @Input() public ghost = false;
  @Input() public disabled = false;
  /**
   * Any extra classes, like float, margin etc.
   */
  @Input() public andClass = '';
  @HostBinding('class') public elementClass: string;
  private readonly _defaultClass: string;

  constructor() {
    this.elementClass = 'btn';
    this._defaultClass = this.elementClass;
  }

  public ngOnChanges(): void {
    const classes = [];
    if (!this.ghost) {
      const colorClass = BTN_CLASS_DICT[this.color];
      classes.push(colorClass);
    } else {
      const colorClass = BTN_OUTLINE_CLASS_DICT[this.color];
      classes.push(colorClass);
    }
    if (this.size) {
      const sizeClass = BTN_SIZE_DICT[this.size];
      classes.push(sizeClass);
    }
    if (this.block) {
      classes.push('btn-block');
    }
    if (this.disabled) {
      classes.push('disabled');
    }
    this.elementClass = this._defaultClass + ' ' + classes.join(' ') + ' ' + this.andClass + ' ';
  }
}
